import { Box, Stack, TextField, Typography } from "@mui/material";
import { useStepperContext } from "../../StepperContext";
import { BRCSelect, ViewCards } from "../../components";
import { QUERYPARAMS } from "../constant";
import { useBatteryOptions } from "../../../../hooks/use-battery-options";

const StepThree = ({ index }) => {
  const { data, activeStep, updateData } = useStepperContext();

  const {
    options: batteryOptions,
    assignedLength,
    isLoading: isBatteryLoading,
  } = useBatteryOptions(data.driverId);

  return (
    <Stack gap={3}>
      {activeStep > index ? (
        <ViewCards view="inBatteryDetails" />
      ) : (
        <>
          <BRCSelect
            label="Select inserted battery ID:"
            options={batteryOptions}
            value={
              (batteryOptions ?? []).find(
                (option) => option.value === data.insertedBatteryId,
              ) || null
            }
            onChange={(selectedOption) => {
              updateData("insertedBatteryId", selectedOption?.value || "");
            }}
            isLoading={isBatteryLoading}
            isDisabled={activeStep > index}
            assignedBatteriesLength={assignedLength}
            menuPlacement="auto"
            maxMenuHeight={200}
            menuPosition="fixed"
          />
          {data.swapType === QUERYPARAMS.INVENTORY ? (
            <Box>
              <Typography variant="body2">Enter battery voltage:</Typography>
              <TextField
                fullWidth
                type="number"
                size="small"
                placeholder="Battery Voltage"
                value={data.insertedBatteryVoltage || ""}
                onChange={(e) =>
                  updateData("insertedBatteryVoltage", e.target.value)
                }
                sx={{ mt: 0.5 }}
              />
            </Box>
          ) : null}
        </>
      )}
    </Stack>
  );
};

export default StepThree;
